import React, { FC, useCallback, useState, useRef }  from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ScrollView, ViewStyle } from "react-native"
import { JalaIcon, Screen, Text, Button, CycleToDoSettingsForm } from "../../../../components"
// import { useStores } from "../../models"
import { color } from "../../../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { View } from "native-base"
import { translate } from "../../../../i18n"
import { useStores } from "../../../../models"
import { goBack } from "../../../../navigators"
import { FormikProps, FormikValues } from "formik"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  // backgroundColor: color.palette.white,
  flexGrow: 1,
}

const BUTTON: ViewStyle = {
  marginVertical: 8,
  marginHorizontal: 23,
  // paddingHorizontal: 60,
  paddingVertical: 10
}

export const ActivitySettingScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function ActivitySettingScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params } } = props
  const { cycleToDoStore, appStore, appStore: { farmStore: { farm } } } = useStores();

  // const [ isError, setIsError ] = useState<boolean>(true);
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ activeStatus, setActiveStatus ] = useState<any[]>(params.activeKeys)

  const scrollViewRef = useRef<ScrollView>(null);
  const todoForm = useRef<FormikProps<FormikValues>>()

  const todoFormRef = useCallback((node) => {
    todoForm.current = node;
    // if (todoForm.current) {
    //   console.tron.log(todoForm, todoForm.current.dirty && todoForm.current.isValid, 'modelref')
    //   setIsError(!(todoForm.current.dirty && todoForm.current.isValid))
    // }
  }, [])

  const onCheck = useCallback((key) => () => {
    const isExist = activeStatus.find(param => param === key);
    if (isExist) {
      const removeIndex = activeStatus.findIndex(param => param === key)
      activeStatus.splice(removeIndex, 1);
      setActiveStatus([...activeStatus]);
    } else {
      activeStatus.push(key);
      setActiveStatus([...activeStatus]);
    }
  }, [activeStatus])

  const onSubmit = async (data) => {
    setLoading(true)
    const filteredData = data.cycle_to_do.filter((i) => data.activeStatus.includes(i.key))
    const existingState = farm.state && farm.state.cycle_to_do
    if (existingState) {
      filteredData.forEach((item) => {
        const index = existingState.findIndex(param => param.key === item.key)
        if (index < -1) existingState[index] = item
        return existingState
      })
    }
    const body = { ...farm, state: { cycle_to_do: filteredData } }
    await cycleToDoStore.updateFarm(body).then((response) => {
      if(response.status === 200 || response.status === 201) {
        JalaAnalytic.log('Mobile App : Activity - Add Activity', { cycle_to_do: body.state.cycle_to_do })
        appStore.getFarms(true, async () => {
          goBack('Home.Stack')
          setLoading(false);
          cycleToDoStore.onRefresh()
        })
      } else {
        setLoading(false);
      }
    }).catch(() => setLoading(false))
  }

  const handleSubmit = (event) => {
    if (todoForm.current) todoForm.current.handleSubmit(event)
  }

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      scrollViewRef={scrollViewRef}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      <View flexGrow={1}>
        <View flexDirection="row" alignItems="flex-start" paddingY="10px" paddingX="16px" backgroundColor={color.palette.orange300}>
          <JalaIcon name="info-1" size={15} color={color.palette.gray800} />
          <Text tx="cycleToDoScreen.settingWarning" preset="body3" color={color.palette.gray800} numberOfLines={2} marginLeft="5px" />
        </View>
        <Text tx="cycleToDoScreen.settingTitle" preset="title4" color={color.palette.darkGrey} marginLeft="16px" marginTop="14px" />
        <CycleToDoSettingsForm
          colorScheme={colorScheme}
          innerRef={todoFormRef}
          onSubmit={onSubmit}
          initialValues={params.initialValues}
          activeStatus={activeStatus}
          onCheckParameter={onCheck}
          isLoading={loading}
        />
      </View>
      <View borderTopWidth="1px" borderTopColor="gray.300" marginTop="5px">
        <Button
          testID="jala:id/activiti-change-status-button"
          text={translate("cycleToDoScreen.saveSetting")}
          colorScheme={colorScheme}
          loading={loading}
          onPress={handleSubmit}
          style={BUTTON}
          disabled={!activeStatus.length}
        />
      </View>
    </Screen>
  )
})
